// import React, { useEffect, useRef } from 'react';
// import Highcharts from 'highcharts';

// interface DataPoint {
//   name: string;
//   y: number;
//   color?: string;
// }

// interface Props {
//   dataSource: DataPoint[];
//   height?: number;
//   width?: number;
//   innerSize?: string;
//   size?: string;
//   className?: string;
// }

// interface LegendItemProps {
//   color: string;
//   label: string;
//   value: string;
// }

// const LegendItem: React.FC<LegendItemProps> = ({ color, label, value }) => (
//   <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', width: 150, marginBottom: 8 }}>
//     <div
//       style={{
//         width: 30,
//         height: 20,
//         backgroundColor: color,
//         borderRadius: 4,
//       }}
//     />
//     <span style={{ flex: 1 }} className='fs-14'>{label}</span>
//     <span className="ms-auto fs-14">{value}</span>
//   </div>
// );

// export const DonutChart: React.FC<Props> = ({
//   dataSource,
//   height = 200,
//   width,
//   innerSize = '70%',
//   size = '80%',
//   className,
// }) => {
//   const chartRef = useRef<HTMLDivElement | null>(null);

//   const chartOptions: Highcharts.Options = {
//     chart: {
//       type: 'pie',
//       backgroundColor: 'transparent',
//       height,
//       width,
//     },
//     title: {
//       text: undefined,
//     },
//     credits: {
//       enabled: false,
//     },
//     tooltip: {
//       enabled: false,
//     },
//     legend: {
//       enabled: false, // We are using custom legends
//     },
//     plotOptions: {
//       pie: {
//         innerSize,
//         size,
//         dataLabels: {
//           enabled: false, // no labels inside chart
//         },
//         colors: dataSource.map((d:any) => d.color),
//       },
//     },
//     series: [
//       {
//         type: 'pie',
//         name: '',
//         data: dataSource,
//       },
//     ],
//     exporting:{
//         enabled:false
//     }
//   };

//   useEffect(() => {
//     if (chartRef.current) {
//       Highcharts.chart(chartRef.current, chartOptions);
//     }
//   }, [dataSource]);

//   // return (
//   //   <div style={{ display: 'flex', alignItems: 'center', gap: '2rem',  padding: '1rem', borderRadius: '10px' }}>
//   //     <div style={{ width: 200 }}>
//   //       <div ref={chartRef} className={className}></div>
//   //     </div>
//   //     <div className=''>
//   //       {dataSource.map((item) => (
//   //         <LegendItem
//   //           key={item.name}
//   //           color={item.color || '#000'}
//   //           label={item.name}
//   //           value={`${item.y}%`}
//   //         />
//   //       ))}
//   //     </div>
//   //   </div>
//   // );
//   return (
//   <div
//     style={{
//       display: 'flex',
//       flexDirection: 'column', // chart on top, legends below
//       alignItems: 'center',
//       gap: '1rem',
//       padding: '1rem',
//       borderRadius: '10px',
//     }}
//   >
//     <div style={{ width: 200 }}>
//       <div ref={chartRef} className={className}></div>
//     </div>

//     {/* Legends in a row */}
//     <div
//       style={{
//         display: 'flex',
//         flexDirection: 'row', // 👈 place legends side by side
//         flexWrap: 'wrap',     // 👈 allow wrapping to next line
//         justifyContent: 'center',
//         gap: '1rem',
//       }}
//     >
//       {dataSource.map((item) => (
//         <LegendItem
//           key={item.name}
//           color={item.color || '#000'}
//           label={item.name}
//           value={`${item.y}%`}
//         />
//       ))}
//     </div>
//   </div>
// );
// };

import React, { useEffect, useRef } from 'react';
import Highcharts from 'highcharts';

interface DataPoint {
  name: string;
  y: number;
  color?: string;
}

interface Props {
  dataSource: DataPoint[];
  height?: number;
  width?: number;
  innerSize?: string;
  size?: string;
  className?: string;
}

interface LegendItemProps {
  color: string;
  label: string;
  value: string;
}

const LegendItem: React.FC<LegendItemProps> = ({ color, label, value }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: '0.3rem',
      minWidth: 100,
      marginBottom: 1,
    }}
  >
    <div
      style={{
        width: 14,
        height: 14,
        backgroundColor: color,
        borderRadius: '50%',
        border: '1px solid #fff',
        boxShadow: '0 1px 2px rgba(0,0,0,0.15)',
      }}
    />
    <span style={{ flex: 1, fontSize: 14, fontWeight: 500, color: '#333' }}>
      {label.charAt(0).toUpperCase() + label.slice(1).toLowerCase()}
    </span>
    <span style={{ fontSize: 14, fontWeight: 600, color: '#555' }}>
      {value}
    </span>
  </div>

);

export const DonutChart: React.FC<Props> = ({
  dataSource,
  height = 220,
  width = 220,
  innerSize = '70%',
  size = '100%',
  className,
}) => {
  const chartRef = useRef<HTMLDivElement | null>(null);

  const chartOptions: Highcharts.Options = {
    chart: {
      type: 'pie',
      backgroundColor: 'transparent',
      height,
      width,
    },
    title: {
      text: undefined,
    },
    credits: {
      enabled: false,
    },
    tooltip: {
      enabled: true,
      pointFormat: '<b>{point.percentage:.1f}%</b>',
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        innerSize,
        size,
        dataLabels: {
          enabled: false,
        },
        colors: dataSource.map((d: any) => d.color),
        borderWidth: 2,
        borderColor: '#fff',
      },
    },
    series: [
      {
        type: 'pie',
        name: '',
        data: dataSource,
      },
    ],
    exporting: {
      enabled: false,
    },
  };

  useEffect(() => {
    if (chartRef.current) {
      Highcharts.chart(chartRef.current, chartOptions);
    }
  }, [dataSource]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '1rem',
        padding: '1.5rem',
        borderRadius: '16px',
        maxWidth: 500,
        margin: '0 auto',
      }}
    >
      <div style={{ width: width, height: height }}>
        <div ref={chartRef} className={className}></div>
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: '1rem',
        }}
      >
        {dataSource.map((item) => (
          <LegendItem
            key={item.name}
            color={item.color || '#000'}
            label={item.name}
            value={`${item.y}%`}
          />
        ))}
      </div>
    </div>
  );
};
